import React from 'react';
import './App.css';
import { WellframeMemberWebRoutes } from 'routes/Routes';

export const App = () => <WellframeMemberWebRoutes />;
